export class RatingsDto {

    feedbackDate: string;
    transactionNo: string;
    toDeliveryBoy: string;
    customerCode: string;


     avgRatingByCustomer: number;
     avgRatingByLocation: number;
}
